<ph-search-select [items]="items"
                  [class.is-disabled]="disabled"
                  [toggles]="toggles"
                  [value]="selectedKey"
                  [placeholder]="placeholder"
                  [hasError]="hasError"
                  [disabled]="disabled"
                  [footerAction]="showAddCategory ? addCategoryAction : null"
                  search-placeholder="Search categories…"
                  empty-label="No matching categories"
                  (ph-change)="onPick($event.detail)"
                  (ph-toggle)="onToggle($event.detail)"
                  (ph-action)="onAction($event.detail)"></ph-search-select>
